import React from 'react';
import FlexListComponent from '../FlexListComponent';
import {
  footerHeadFontBoldStyle,
  footerHeadFontStyle
} from '../../partnerStyles';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import * as IMAGES from '../../Images';
import FlexListWithLinks from '../FlexListWithLinks';

const FooterGeneralContent = props => {
  let textList = [];
  let linksList = [];
  return (
    <div style={{ display: 'flex', height: '225px' }}>
      <FlexListWithLinks
        list={[
          [
            {
              text: props.globalData.universal_translations.our_story,
              link: props.globalData.universal_translations.our_story_link
            },
            {
              text: props.globalData.universal_translations.official_oyo_blog,
              link:
                props.globalData.universal_translations.official_oyo_blog_link
            },
            {
              text: props.globalData.universal_translations.press_kit,
              link: props.globalData.universal_translations.press_kit_link
            },
            {
              text: props.globalData.universal_translations.support,
              link: props.globalData.universal_translations.support_link
            }
          ],

          [
            {
              text:
                props.globalData.universal_translations.terms_and_conditions,
              link: props.globalData.universal_translations.tnc_link
            },
            {
              text: props.globalData.universal_translations.guest_policy,
              link: props.globalData.universal_translations.guest_policy_link
            },
            {
              text: props.globalData.universal_translations.privacy_policy,
              link: ''
            }
          ]
        ]}
        divStyle={{
          width: '38%',
          marginTop: '30px',
          borderRight: '#aaa solid 0.1px',
          marginBottom: '30px'
        }}
        uniformWidths={true}
        text_style={footerHeadFontStyle}
      />

      <div
        style={{
          width: '24%',
          marginTop: '30px',
          padding: 'auto',
          marginBottom: '30px'
        }}
      >
        <div style={{ ...footerHeadFontBoldStyle, margin: '0 15%' }}>
          {props.globalData.universal_translations.footer_c2_1_header}
        </div>
        <div style={{ ...footerHeadFontStyle, margin: '0 15%' }}>
          {' '}
          {props.globalData.universal_translations.footer_c2_1_content}
        </div>

        <div style={{ ...footerHeadFontBoldStyle, margin: '15% 15% 0% 15%' }}>
          {props.globalData.universal_translations.footer_c2_2_header}
        </div>
        <div style={{ ...footerHeadFontStyle, margin: '0 15%' }}>
          {' '}
          {props.globalData.universal_translations.footer_c2_2_content}
        </div>
      </div>

      <div
        style={{
          width: '38%',
          marginTop: '30px',
          borderLeft: '#aaa solid 0.1px',
          marginBottom: '30px'
        }}
      >
        <div style={{ marginLeft: '40px', ...footerHeadFontStyle }}>
          <div>
            <span>{props.globalData.universal_translations.footer_c3_l1}</span>
            <span style={{ textDecoration: 'underline', marginLeft: '2%' }}>
              {props.globalData.universal_translations.footer_c3_l2}
            </span>
          </div>
          <div style={{ marginTop: '16px' }}>
            <img
              width="180px"
              src={IMAGES.DESKTOP_APPLE_APP_STORE}
              alt="Apple App store"
            />
            <img
              width="202px"
              src={IMAGES.DESKTOP_PLAYSTORE}
              alt="Playstore"
              style={{ marginLeft: '7.18%' }}
            />
          </div>
          <div style={{ marginTop: '24px' }}>
            <span>{props.globalData.universal_translations.footer_c3_l3} </span>
            <span style={{ textDecoration: 'underline', marginLeft: '2%' }}>
              {props.globalData.universal_translations.footer_c3_l4}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterGeneralContent);
